import api from './api';

export const ticketsAPI = {
  create: (data) => api.post('/api/tickets', data),
  getById: (id) => api.get(`/api/tickets/${id}`),
  list: (params) => api.get('/api/tickets', { params }),
  update: (id, data) => api.patch(`/api/tickets/${id}`, data),
  capacidadRango: (lugar, dias = 90) => api.get('/api/capacidad-rango', { params: { lugar, dias } }),
};

export const geocodeAPI = {
  geocode: (address) => api.get('/api/geocode', { params: { address } }),
};

export const vehiculosAPI = {
  list: (params) => api.get('/api/vehiculos', { params }),
  create: (data) => api.post('/api/vehiculos', data),
  getById: (id) => api.get(`/api/vehiculos/${id}`),
  toggleFavorito: (id, favorito) => api.patch(`/api/vehiculos/${id}/favorito`, null, { params: { favorito } }),
  getFavoritos: () => api.get('/api/vehiculos/favoritos'),
};

export const rutasAPI = {
  list: (params) => api.get('/api/rutas', { params }),
  create: (data) => api.post('/api/rutas', data),
  getById: (id) => api.get(`/api/rutas/${id}`),
  optimize: (data) => api.post('/api/rutas/optimize', data),
  createOptimized: (data) => api.post('/api/rutas/crear-optimizada', data),
  changeState: (id, data) => api.post(`/api/rutas/${id}/estado`, data),
  complete: (id, data) => api.post(`/api/rutas/${id}/completar`, data),
  exportPDF: (id) => {
    const backendUrl = import.meta.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
    window.open(`${backendUrl}/api/rutas/${id}/export/pdf`, '_blank');
  },
};

export const exportAPI = {
  ticketsXLSX: (params) => {
    const backendUrl = import.meta.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
    const queryParams = new URLSearchParams();
    if (params.fecha_desde) queryParams.append('fecha_desde', params.fecha_desde);
    if (params.fecha_hasta) queryParams.append('fecha_hasta', params.fecha_hasta);
    if (params.estado) queryParams.append('estado', params.estado);
    if (params.lugar) queryParams.append('lugar', params.lugar);
    window.open(`${backendUrl}/api/export/tickets?${queryParams.toString()}`, '_blank');
  },
};

export const arcgisAPI = {
  syncAll: () => api.post('/api/arcgis/sync-all'),
  syncTicket: (ticketId) => api.post(`/api/arcgis/sync-ticket/${ticketId}`),
  getToken: () => api.get('/api/arcgis/token'),
};
